import React from "react";
import useInsightsDrilldown from "hooks/useInsightsDrilldown";
import useWorkspaceMeetingNavigator from "hooks/useWorkspaceMeetingNavigator";
import useWorkspaceActionsPanelNavigator from "hooks/useWorkspaceActionsPanelNavigator";
import useActionsStore from "stores/useActionsStore";
import { useFloatingMicAssistant } from "components/FloatingMicAssistant/FloatingMicAssistantContext";
import css from "./OrgBrief.module.scss";

// "Ask GT a follow-up" is hidden for now. The server still writes the
// question, and the chat hand-off (askAssistant) still works; set this to
// true to bring the link back.
const SHOW_FOLLOW_UP = false;

const isTaskDone = (actionItems, actionId) =>
  actionItems.some((item) => item.id === actionId && item.completed);

export default function OrgBriefCard({ brief, uid }) {
  const { openDrilldown } = useInsightsDrilldown();
  const openMeeting = useWorkspaceMeetingNavigator();
  const openActions = useWorkspaceActionsPanelNavigator();
  const { askAssistant } = useFloatingMicAssistant();
  const actionItems = useActionsStore((state) => state.actionItems);

  const action = brief.action;
  // A task finished after the brief was written no longer needs a link.
  const showAction =
    action && !(action.kind === "task" && isTaskDone(actionItems, action.actionId));

  const runAction = () => {
    if (action.kind === "event") {
      // The start as written in the calendar, with its own offset, so the
      // workspace opens the meeting's day rather than the UTC day.
      openMeeting({ eventId: action.eventId, startDateTime: action.startDateTime || action.startIso });
    } else if (action.kind === "task") {
      openActions({ heading: brief.label, actionIds: [action.actionId] });
    } else if (action.kind === "drilldown" && uid) {
      openDrilldown({
        name: action.drilldown.name,
        type: action.drilldown.type,
        meetingType: "All",
        redisKeys: action.drilldown.keys.map((key) => `users:${uid}:orgCalculations:${key}`),
      });
    }
  };

  return (
    <section className={`${css.card} ${css.summaryCard}`} aria-label="What to do this week">
      <div className={css.kicker}>
        <span className={css.dot} aria-hidden="true" />
        {brief.label}
      </div>
      <p className={css.text}>
        {brief.segments.map((segment, index) =>
          segment.value ? <b key={index}>{segment.text}</b> : <React.Fragment key={index}>{segment.text}</React.Fragment>,
        )}
      </p>
      <div className={css.links}>
        {showAction && (
          <button type="button" className={css.link} onClick={runAction}>
            {action.label}
          </button>
        )}
        {SHOW_FOLLOW_UP && brief.followUpQuestion && (
          <button type="button" className={css.link} onClick={() => askAssistant(brief.followUpQuestion)}>
            Ask GT a follow-up
          </button>
        )}
      </div>
    </section>
  );
}
